import {urlServer} from "../api/v1";
import {IMaterial} from "../varibles/interface";
import {api} from "../api/callApi";
import {firstLetter} from "../varibles/global";

const urlBase = urlServer + '/material'

export const MaterialService = {
    gets: () => {
        return api.get<IMaterial[]>(urlBase + '/s')
    },
    getTypes: () => {
        return api.get<string[]>(urlBase + '/types')
            .then(rs => rs.map(item => {
                return {id: item, name: firstLetter(item.replace(/_/g, ' '))}
            }))
    }
}